/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetAssetYTMByIdOptions, GetAssetYTMByIdResponses } from '../types/GetAssetYTMById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get annualized yield to maturity for a bond asset
 * {@link /v1/assets/:asset_id/ytm}
 */
export function getAssetYTMById<ThrowOnError extends boolean = true>(
  options: Options<GetAssetYTMByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetAssetYTMByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/assets/{asset_id}/ytm',
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAssetYTMByIdResponses, ThrowOnError>>,
  )
}
